import { createSelector } from '@reduxjs/toolkit';

import type { IState } from 'shared/store';

import { selectIsEtazhiBlackFridayEnabled } from './selectIsEtazhiBlackFridayEnabled';

export const selectEtazhiBlackFridayPromoOffersData = createSelector(
  (state: IState) => state,
  selectIsEtazhiBlackFridayEnabled,
  (state, isEnabled) => {
    if (!isEnabled) {
      return null;
    }

    return state.rs.etazhiBlackFridayPromoOffersData;
  },
);
